import {styledByTheme} from "../../../themes/architecture/styled-by-theme";
import {IndicatorIconWrapperDefaultBox} from "./indicator-icon-wrapper-default.box";
import {IndicatorIconWrapperSIBox} from "./indicator-icon-wrapper.si.box";
import {IndicatorIconWrapper777Box} from "./indicator-icon-wrapper.777.box";

export const IndicatorIconWrapperBox = styledByTheme(IndicatorIconWrapperDefaultBox)
    .forCasino777(IndicatorIconWrapper777Box)
    .forSI(IndicatorIconWrapperSIBox).apply();